var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowthrigtharrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9818 7.6673L9.88553 13.4865C9.53915 13.7983 9.01957 13.7983 8.70783 13.4519C8.39609 13.1055 8.39609 12.5859 8.74247 12.2742L13.3493 7.87513H1.57237C1.08743 7.87513 0.741053 7.52874 0.741053 7.04381C0.741053 6.59351 1.08743 6.21249 1.57237 6.21249H13.3493L8.74247 1.84809C8.39609 1.53634 8.39609 0.982132 8.70783 0.670388C9.01957 0.324007 9.57378 0.324007 9.88553 0.63575L15.9818 6.45496C16.155 6.62815 16.2589 6.83598 16.2589 7.04381C16.2589 7.28628 16.155 7.49411 15.9818 7.6673Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthrigtharrow);
export default __webpack_public_path__ + "static/media/growthrigtharrow.8803d4f991117b0c0ba125a4b40d563c.svg";
export { ForwardRef as ReactComponent };